import router from '@/modules/invoice/router'
import { useInvoiceStore } from '@/modules/invoice/store'
import InvoiceApi from '@/modules/invoice/service'

export default {
  router,
  service: new InvoiceApi(),
  store: useInvoiceStore,
}
